import { getFileType } from "@/utils/getFileType"
import { DefaultList } from "@components/default-list"
import { LabeledValue } from "@components/default-list/labeled-value"
import { Card, Center, Spoiler, Text } from "@mantine/core"
import { IconPhotoOff } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"
import { ResourceImage } from "./ResourceImage"
import { SimpleAttachment } from "@/orval/gen/model"
import { FieldData } from "@/orval/gen/model"
import { FieldData as FieldDataComponent } from "@components/field-data"

interface ResourceCardProps {
  title: string
  attachments: SimpleAttachment[]
  resourceId: number
  defaultFields: { label: React.ReactNode; value: string }[]
  fieldData: FieldData[] | undefined
  expanded: boolean
  onExpandedChange: (expanded: boolean) => void
}

export function ResourceCard({
  title,
  attachments,
  resourceId,
  defaultFields,
  fieldData = [],
  expanded,
  onExpandedChange,
}: ResourceCardProps) {
  const { t } = useTranslation("app_server")
  const image = attachments.find((a) => getFileType(a.fileName) === "image")
  return (
    <Card h={"100%"} w={300} maw={"100%"} shadow="md">
      <Text fw={"bold"} fz={"lg"} truncate lineClamp={1}>
        {title}
      </Text>
      <Card.Section>
        {image ? (
          <ResourceImage
            attachmentId={image.attachmentId}
            resourceId={resourceId}
            w={300}
            h={300}
          />
        ) : (
          <Center h={300} mah={"100%"}>
            <IconPhotoOff color="gray" size={100} />
          </Center>
        )}
      </Card.Section>
      <Spoiler
        maxHeight={130}
        showLabel={t("ShowMore")}
        hideLabel={t("ShowLess")}
        expanded={expanded}
        onExpandedChange={onExpandedChange}
        onClick={(e) => e.stopPropagation()}
      >
        {defaultFields
          .filter((f) => !!f.value)
          .map((field, i) => (
            <LabeledValue key={i} {...field} />
          ))}
        <DefaultList
          data={fieldData}
          renderItem={({ entity: fieldData }) => (
            <LabeledValue
              label={fieldData?.name}
              value={<FieldDataComponent fieldData={fieldData ?? undefined} />}
            />
          )}
        ></DefaultList>
      </Spoiler>
    </Card>
  )
}
